import { Grid } from '@mui/material';
import React, { useContext } from 'react'
import { CONSTANTS } from '../../common/utility/constant';
import {useState} from "react";
// import { createOrientPopupCloseHandler, markOrientPopupDismissed } from '../../common/utility/orientPopup';
// import { UserSettingsContext } from '../../setup/routes-manager/RequireAuth';

function MarketProfile() {
    const [CurrentComponent, setCurrentComponent] = useState(null);
    // const [showToolsWalkthrough, setShowToolsWalkthrough] = useState(false);
    const setRoute = (route, component) => { setCurrentComponent(component); };
    // const {showWelcomeModal,setShowWelcomeModal,setShowToolsWalkthrough} = useContext(UserSettingsContext)
    // const handleStartExploring = () => {
    //     markOrientPopupDismissed();
    //     setShowWelcomeModal(false);
    //     setShowToolsWalkthrough(true);
    // };

    return (
        <>
            {/* <DashboardHeader
                setCurrentRoute={setRoute}
                openToolsWalkthrough={() => setShowToolsWalkthrough(true)}
            /> */}
            
            <div
                style={{ paddingTop: `${CONSTANTS.DASHBOARD_HEADER_HEIGHT}px` }}
            >
                <Grid
                    container
                    component="main"
                    sx={{
                        height: `calc(100vh - ${CONSTANTS.DASHBOARD_HEADER_HEIGHT}px)`,
                    }}
                >
                    {CurrentComponent != null ? CurrentComponent : <></>}
                </Grid>
            </div>
        </>
    );
}

export default MarketProfile
